import type { PackagingFormat, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/packaging-formats';

export function getPackagingFormats(query: PackagingFormat.SearchQuery) {
    return api.get<Pagination<PackagingFormat>>(`${rootPath}`, query);
}

export function getPackagingFormat(id: number) {
    return api.get<PackagingFormat.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postPackagingFormat(data: PackagingFormat.CreateRequest) {
    return api.post<PackagingFormat>(`${rootPath}`, data);
}

export function putPackagingFormat(
    id: number,
    data: PackagingFormat.UpdateRequest
) {
    return api.put<PackagingFormat>(`${rootPath}/${id}`, data);
}

export function deletePackagingFormat({ id }: PackagingFormat.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
